import type { Stop } from '@getcircuit/schema'

import type { AddressSearchResultItem, StopData } from './types'

export function getDefaultStopData(): Stop {
  return {
    addedTime: Math.floor(Date.now() / 1000),
    address: '',
    addressLineOne: '',
    addressLineTwo: '',
    arrivalTime: -1,
    deliveryInfo: null,
    departureTime: -1,
    distanceMeters: -1,
    done: false,
    doneTime: -1,
    driver: '',
    driverIdentifier: null,
    durationSeconds: -1,
    estimatedTimeAtStop: -1,
    lastEdited: -1,
    latitude: null,
    longitude: null,
    nextStopClickedTime: 0,
    nextStopTime: Number.MAX_SAFE_INTEGER,
    notes: '',
    optimized: false,
    orderCount: 1,
    packageId: null,
    packageSize: null,
    pickups: 0,
    placeId: null,
    placeInVehicle: null,
    placeTypes: [],
    plan: null,
    polyLineString: null,
    previouslyDone: false,
    priority: 1,
    recipient: null,
    route: null,
    searchToken: null,
    skippedReason: -1,
    timeWindowEarliestTime: -1,
    timeWindowLatestTime: -1,
    tracked: false,
    type: 'stop',
  }
}

export function createStop({
  address,
  countryCode,
  addressLineOne,
  addressLineTwo,
  latitude,
  longitude,
  placeId,
  searchToken,
  placeTypes,
}: Pick<
  StopData,
  | 'address'
  | 'addressLineOne'
  | 'addressLineTwo'
  | 'latitude'
  | 'longitude'
  | 'placeId'
  | 'searchToken'
  | 'placeTypes'
  | 'countryCode'
>): Stop {
  return {
    ...getDefaultStopData(),
    address,
    addressLineOne,
    addressLineTwo,
    countryCode,
    latitude,
    longitude,
    placeId,
    placeTypes,
    searchToken,
    addedTime: Math.floor(Date.now() / 1000),
  }
}

export function mapAddressSearchResultItemToStop(
  resultItem: AddressSearchResultItem,
): Stop {
  return createStop({
    address: resultItem.address,
    countryCode: resultItem.countryCode,
    addressLineOne: resultItem.addressLineOne,
    addressLineTwo: resultItem.addressLineTwo,
    latitude: resultItem?.latitude,
    longitude: resultItem?.longitude,
    placeId: resultItem.placeId,
    placeTypes: resultItem.placeTypes,
    searchToken: resultItem.searchToken,
  })
}
